import { FC, ReactElement } from "react";
import { 
    Box, 
    // Chip, 
    // Typography 
} from "@mui/material";
// import { CheckBoxRounded, CloseRounded } from "@mui/icons-material"
// import { 
//     useReportsConfirmed,
// } from "../../hooks";
// import { LazyTooltip } from ".";


export const NotificationBar: FC = (): ReactElement => {
    // const { isConfirm, confirmDate } = useReportsConfirmed()

    // const confirmLabel =  " تاریخ تائید: " + confirmDate 
    return (
        <Box 
            display='flex'
            justifyContent='flex-end'
            sx={{
                backgroundColor:'rgba(205, 231, 247, 0.45)',
                mt:0, mb:6, 
            }}
        >
            {/* {
                isConfirm ==='confirmed'
                ? <Chip 
                    size="small"
                    icon={<CheckBoxRounded/>} 
                    variant="filled" 
                    label={
                    <>
                        <LazyTooltip placement="bottom-end" title={confirmLabel}>
                            <Typography variant="button" fontFamily='B Nazanin'  fontWeight={600}>
                            تائید شده است 
                            </Typography>
                        </LazyTooltip>
                    </>
                    } 
                    color="success"  
                    
                    sx={{pr:1.5, ml:1}}
                  />
                : 
                isConfirm ==='notConfirmed'
                ?
                  <Chip 
                    size="small"
                    icon={<CloseRounded/>} 
                    variant="filled" 
                    label={
                        <Typography variant="button" fontFamily='B Nazanin' fontWeight={600}>
                            تائید نشده است
                        </Typography>                    
                    }
                    color="error"
                    sx={{pr:1.5, ml:1}}
                  />
                :
                ''
            } */}
        </Box>
    )
}